// extracted by mini-css-extract-plugin
export var grid = "_2o-0";
export var span1 = "_2o-2";
export var span10 = "_2o-b";
export var span10L = "_2o-z";
export var span10M = "_2o-n";
export var span10Xl = "_2o-1b";
export var span11 = "_2o-c";
export var span11L = "_2o-10";
export var span11M = "_2o-o";
export var span11Xl = "_2o-1c";
export var span12 = "_2o-d";
export var span12L = "_2o-11";
export var span12M = "_2o-p";
export var span12Xl = "_2o-1d";
export var span1L = "_2o-q";
export var span1M = "_2o-e";
export var span1Xl = "_2o-12";
export var span2 = "_2o-3";
export var span2L = "_2o-r";
export var span2M = "_2o-f";
export var span2Xl = "_2o-13";
export var span3 = "_2o-4";
export var span3L = "_2o-s";
export var span3M = "_2o-g";
export var span3Xl = "_2o-14";
export var span4 = "_2o-5";
export var span4L = "_2o-t";
export var span4M = "_2o-h";
export var span4Xl = "_2o-15";
export var span5 = "_2o-6";
export var span5L = "_2o-u";
export var span5M = "_2o-i";
export var span5Xl = "_2o-16";
export var span6 = "_2o-7";
export var span6L = "_2o-v";
export var span6M = "_2o-j";
export var span6Xl = "_2o-17";
export var span7 = "_2o-8";
export var span7L = "_2o-w";
export var span7M = "_2o-k";
export var span7Xl = "_2o-18";
export var span8 = "_2o-9";
export var span8L = "_2o-x";
export var span8M = "_2o-l";
export var span8Xl = "_2o-19";
export var span9 = "_2o-a";
export var span9L = "_2o-y";
export var span9M = "_2o-m";
export var span9Xl = "_2o-1a";
export var stretch = "_2o-1";